import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit, ViewChildren } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-adddoctype',
  templateUrl: './adddoctype.component.html',
  styleUrls: ['./adddoctype.component.css']
})
export class AdddoctypeComponent implements OnInit, AfterViewInit {

  @ViewChildren('input') firstipcontrol;

  formname: string = "DocType";

  //Display
  formmode: string = "Add";

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;


  //Save Validation
  submitted: boolean;
  successfully: boolean;

  saveloading: boolean;

  //Edit Get Values
  doctypeColl: any = [];
  doctypeBO: any = {};
  doctypeid: number = 0

  alerttypeColl: any = [];

  doctypeform = new FormGroup({
    doctypeid: new FormControl(0),
    doctypename: new FormControl('', Validators.required),
    alertdaysbefore: new FormControl(null),
    alerttypeid: new FormControl(null),
    inactive: new FormControl(false),
    isexpirydt: new FormControl(false),
    isissuedt: new FormControl(false),
    isdocnum: new FormControl(false),
    ismandatory: new FormControl(false),
    isunique: new FormControl(false),
    iscompany: new FormControl(false),
    isemployee: new FormControl(false),

  });


  @Input() ischild: boolean = false;
  @Input() ischildadd: boolean = false;
  @Input() ischildkey: number = 0
  @Output() childChanged = new EventEmitter<number>();


  constructor(private appService: AppdataService, private loginService: LoginserviceService, private route: ActivatedRoute,
    public router: Router, private toastr: ToastrService, private productFindService: NgbModal) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.doctypeid = params.id
      }
    });

    this.fnServiceChanges();
  }


  fnServiceChanges() {
    this.loginService.serviceAuthChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.fnUserFailedForm();
      }

    });
  }



  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.doctypeform.reset();
      this.fnInitializeFormGroup();

      if (this.doctypeid > 0) {
        this.fngetDocType();
      }

      this.fngetAlertType();
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.doctypeid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }
  ngAfterViewInit() {
    this.loginService.fnSetFirstControlFocus('txtfirst');
  }
  fnInitializeFormGroup() {
    this.doctypeform.setValue({
      doctypeid: 0,
      doctypename: '',
      alertdaysbefore: null,
      alerttypeid: null,
      isexpirydt: false,
      isissuedt: false,
      isdocnum: false,
      ismandatory: false,
      isunique: false,
      iscompany: false,
      isemployee: false,
      inactive: false
    })
  }


  fngetAlertType() {
    var data = {
      'alerttypeid': 0,
      'companyid': this.loginService.fnGetCompanyId()
    }
    this.appService.getAlerttype(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.alerttypeColl = res.json().result;
          }
          else {
            this.loginService.fnAPIError(res.json())
          }

        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  //Get 
  fngetDocType() {
    if (this.showProgress) {
      return;
    }
    var data = {
      'doctypeid': this.doctypeid,
      'companyid': this.loginService.fnGetCompanyId()
    }
    this.appService.getDocType(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.fnHideProgress();

            this.doctypeColl = res.json().result;
            console.log(this.doctypeColl)
            var editdata = this.doctypeColl[0];
            this.fnEditMode(editdata);
            this.doctypeBO = editdata;
          }
          else {
            this.fnHideProgress();

            this.loginService.fnAPIError(res.json())
          }

        },
        (err) => {
          this.fnHideProgress();

          this.toastr.error('Error', err);
        })
  }



  //Save Btn Click
  fnSaveBtnClick() {
    try {
      if (this.saveloading) {
        return;
      }

      this.submitted = true;
      this.successfully = false;
      if (this.loginService.fnCheckFornControlNotfound(this.doctypeform.get('iscompany'))) {
        this.doctypeform.controls['iscompany'].setErrors(null);
      }

      //Validate
      if (this.doctypeform.valid) {

        if (!this.doctypeform.get('iscompany').value && !this.doctypeform.get('isemployee').value) {
          this.doctypeform.controls['iscompany'].setErrors({ 'notfound': true });
          return
        }


        //Check
        this.saveloading = true;
        var data = {
          'doctypeid': this.doctypeid,
          'doctypename': this.doctypeform.get('doctypename').value,
          'alertdaysbefore': this.doctypeform.get('alertdaysbefore').value,
          'alerttypeid': this.doctypeform.get('alerttypeid').value,
          'isexpirydt': this.doctypeform.get('isexpirydt').value,
          'isissuedt': this.doctypeform.get('isissuedt').value,
          'isdocnum': this.doctypeform.get('isdocnum').value,
          'ismandatory': this.doctypeform.get('ismandatory').value,
          'isunique': this.doctypeform.get('isunique').value,
          'iscompany': this.doctypeform.get('iscompany').value,
          'isemployee': this.doctypeform.get('isemployee').value,
          'inactive': this.doctypeform.get('inactive').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }


        this.appService.fnCheckDocType(data).subscribe(
          (res) => {
            if (res.json().status === 200) {
              var _checkresult = res.json().result[0].checkfield;

              if (_checkresult === "done") {
                if (this.doctypeform.get('doctypeid').value > 0) {
                  //Update 
                  this.fnSetDocType(data);
                }
                else {
                  //Insert 
                  this.fnInsertDocType(data);
                }
              }
              else {
                if (_checkresult === "name") {
                  this.saveloading = false;

                  this.doctypeform.controls['doctypename'].setErrors({ 'notfound': true });
                }
              }
            }
            else {
              this.saveloading = false;

              this.loginService.fnAPIError(res.json())
            }
          },
          (err) => {
            this.saveloading = false;

            this.toastr.error('Error', err);
          });
      }
    } catch (ex) {
      this.saveloading = false;

      this.fnShowErrorMsg(ex);
    }
  }

  //Insert
  fnInsertDocType(data) {

    this.appService.fnInsertDocType(data).subscribe(
      (res) => {
        this.saveloading = false;

        if (res.json().status === 200) {
          if (res.json().result != "") {


            // this.ischildkey = res.json().result[0][0].doctypeid;
            // this.ischildadd = true;

            this.toastr.success('', "The new doctype has been added successfully.Insert Successfully");
            this.fnInsertActivityLog('INSERT', 0, data.doctypename);

            this.fnCloseForm();
          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.saveloading = false;

        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetDocType(data) {

    this.appService.fnSetDocType(data).subscribe(
      (res) => {
        this.saveloading = false;

        if (res.json().status === 200) {
          if (res.json().result != "") {
            this.toastr.success('', "The doctype has been updated successfully.");
            this.fnInsertActivityLog('EDIT', this.doctypeid, data.doctypename);
            this.fnCloseForm();
          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.saveloading = false;

        this.toastr.error('Error', err);
      });

  }

  //Close
  fnCloseForm() {
    try {
      if (this.ischild === false) {
        this.router.navigate(['/DocType']);
      }
      else {
        var pBO: any = {
          isadd: this.ischildadd,
          childkey: this.ischildkey,
          doctype: 'doctype'
        }
        this.childChanged.emit(pBO);
      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  private fnEditMode(deptBO) {
    this.doctypeform.setValue({
      doctypeid: deptBO.doctypeid,
      doctypename: deptBO.doctypename,
      alertdaysbefore: deptBO.alertdaysbefore,
      alerttypeid: deptBO.alerttypeid,
      isexpirydt: deptBO.isexpirydt,
      isissuedt: deptBO.isissuedt,
      isdocnum: deptBO.isdocnum,
      ismandatory: deptBO.ismandatory,
      isunique: deptBO.isunique,
      iscompany: deptBO.iscompany,
      isemployee: deptBO.isemployee,
      inactive: deptBO.inactive
    });

    this.formmode = "Edit";

    this.iseditmode = true;
    this.isdeletemode = false;
    this.isviewmode = false;
  }

  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }
  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }
  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }







}
